import { render, staticRenderFns } from "./bGround.vue?vue&type=template&id=306a6e5c&scoped=true"
import script from "./bGround.vue?vue&type=script&lang=js"
export * from "./bGround.vue?vue&type=script&lang=js"
import style0 from "./bGround.vue?vue&type=style&index=0&id=306a6e5c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "306a6e5c",
  null
  
)

export default component.exports